import React, {Component} from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import moment from 'moment';
import '../../../assets/css/Supervisor.css';

import Utils from "../../../utils/utils";
import "react-datepicker/dist/react-datepicker.css";
import {
    CircularProgress,
} from '@material-ui/core';
import Sidebar from "../../../components/Sidebar";
import { checkPermission } from "../../../utils/common";
import UserController from "../../../services/system/user/user-controller";
import DatePicker, {registerLocale} from "react-datepicker";
import vi from "date-fns/locale/vi";
import ModalChangePassword from "./modalChangePassword";
import ModalConfirmEdit from "./modalConfirmEdit";
import UploadFile from "./modalUploadFile";
import ModalConfirmDeleteCert from "./modalConfirmDeleteCert";
import ModalChangeAvatar from "./ModalChangeAvatar";
import AddressManager from "../../../components/Address";
import Cookies from "js-cookie";
registerLocale("vi", vi);
class ProfilePartner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            onEdit: false,
            inEditing: false,
            showUpload: false,
            dataInfo: [],
            listProvince: [],
            listDistrict: [],
            files: [],
            filesCertificate: [],
            modalConfirmDeleteCert: false,
            fileId: null,
            modalUploadAvatar: false,
            showLoading: false,
            phone1:'',
            phone2:'',
            provinceCode:'',
            religion:'NO',
            socialInsuranceNumber:'',
            status:'INACTIVE',
            email:'',
            fullName:'',
            ethnic:'KINH',
            birthday: new Date(),
            memberDay: new Date(),
            partyMemberDay: new Date(),
            provinceId:'',
            districtId:'',
            wardId:'',
            addressUsually:'',
            website:'',
            representativeName:'',
            gender:'MALE',
            identifyCard:'',
            dateIdentifyCard:'',
            placeIssue:'',
            position:'',

            fullNameErr:false,
            phoneErr:false,
            emailErr:false,
            provinceIdErr:false,
            districtIdErr:false,
            addressErr:false,
            websiteErr:false,
            representativeNameErr:false,
            genderErr:false,
            identifyErr:false,
            dateIdentifyCardErr:false,
            placeIssueErr:false,
            positionErr:false,
            btnSaveStatus:false,

            showConfirmModal: false,
            loading: false,
            progress: 0,
            confirmCancel: false,
            showModalChangePassword: false,
        }
    }
    UNSAFE_componentWillMount() {
        this.setState({showLoading: true}, () => {
            this.getProfile();
            this.state.files.forEach(file => URL.revokeObjectURL(file.preview))
        })
    }

    handleShowModalForgotPassword = () => {
            this.setState({showModalChangePassword: true});
    };

    onCloseModalForgotPassword = () => {
        this.setState({showModalChangePassword: false});
    }
    getProfile() {
        UserController.detailSelf(res => {
            if (res.success) {
                let data = res.data;
                this.setState(
                    {
                        dataInfo: data,
                        fullName: data.fullName,
                        phone1: data.phone1,
                        email: data.email,
                        provinceId: data.provinceRes?data.provinceRes.code: "01",
                        districtId: data.districtRes?data.districtRes.code: "001",
                        wardId: data.wardRes?data.wardRes.code: "00001",
                        addressUsually: data.addressUsually,
                        website: data.website,
                        urlImage:  data.urlImage,
                        representativeName: data.representative,
                        gender: data.gender,
                        status: data.status,
                        identifyCard: data.identifyCard,
                        dateIdentifyCard: data.dateIdentifyCard,
                        provinceIdentifyCard: data.provinceIdentifyCard,
                        position: data.position,
                        showLoading: false
                    }
                );
            } else {
                toast.error("Đã có lỗi xảy ra trong quá trình lấy dữ liệu, vui lòng tải lại trang!")
            }
        });
    };
    componentDidMount() {
        document.title = 'Thông tin cá nhân';
    }

    handleSave() {
        let {
            status,
            addressUsually,
            birthday,
            dateIdentifyCard,
            districtId,
            provinceId,
            wardId,
            email,
            ethnic,
            fullName,
            gender,
            identifyCard,
            memberDay,
            partyMemberDay,
            phone1,
            phone2,
            religion,
            provinceIdentifyCard,
            socialInsuranceNumber
        } = this.state;
        let payload = {
            status: status,
            addressUsually: addressUsually,
            birthday: birthday,
            dateIdentifyCard: dateIdentifyCard,
            districtCode: districtId,
            provinceCode: provinceId,
            wardCode: wardId,
            email: email,
            ethnic: ethnic,
            fullName: fullName,
            gender: gender,
            identifyCard: identifyCard,
            memberDay: memberDay,
            partyMemberDay: partyMemberDay,
            phone1: phone1,
            phone2: phone2,
            religion: religion,
            provinceIdentifyCard: provinceIdentifyCard,
            socialInsuranceNumber: socialInsuranceNumber
        };
        UserController.editUser(payload, res => {
            if (res.success) {
                toast.success("Cập nhật thông tin thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
                this.setState({
                    confirmCancel: false,
                    inEditing: false
                }, () => this.handleCancel())
                this.getProfile();
            } else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }

    handleCancel() {
        if (this.state.inEditing) {
            this.setState({
                confirmCancel: true
            })
        } else {
            this.setState({onEdit: false},
                () => {
                    this.setState({
                        taxcodeErr:false,
                        phoneErr:false,
                        emailErr:false,
                        addressErr:false,
                        websiteErr:false,
                        representativeNameErr:false,
                        genderErr:false,
                        identifyErr:false,
                        dateIdentifyCardErr:false,
                        placeIssueErr:false,
                        positionErr:false,
                        btnSaveStatus:true,
                    })
                }
            )
        }
    }

    modalUploadAvatarClose = () => {
        this.setState({modalUploadAvatar: false});
    };
    modalCropClose = () => {
        this.setState({showModalCrop: false});
    };

    showModalUploadAvatar = () => {
        this.setState({modalUploadAvatar: true})
    };

    onDeleteCert = (item) => {
        this.setState({fileId: item.id, modalConfirmDeleteCert: true})
    };

    render() {
        const {addressUsually, wardId, districtId, provinceId, dataInfo} = this.state;
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="profile"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div variant="outlined" className='mb-4 pb-2 card border-color'>
                                {/*//**********************************************Thong tin doanh nghiep****************************************************************************************************/}
                                <div className='d-flex col-12 mt-1 kt-margin-b-20 card-header'>
                                    <span className='text-header-profile'>Thông tin cá nhân</span>
                                </div>
                                <div className='col-12 mt-3' style={{display: "none"}}>
                                    <div className='justify-center img-logo-wrapper' style={{textAlign: 'center', backgroundImage: dataInfo.urlImage ? `url(${dataInfo.urlImage}` : `url("/images/no-avatar-png.png")`}}>
                                    </div>
                                    {(checkPermission("change_logo")) &&
                                    <div>
                                        <span className="fas fa-camera change-logo-icon" title="Tải lên ảnh đại diện" onClick={()=> this.setState({modalUploadAvatar: true})}/>
                                    </div>
                                    }
                                </div>

                                <div className="mb-4 mt-4 font-14 ml-2 mr-2">
                                    {/*Hien thi chỉnh sửa*/}
                                    {
                                        this.state.onEdit &&
                                        <div className='row kt-margin-b-20'>
                                            <div className="d-flex mb-2 col-xs-12 col-md-6">
                                                <label className="col-md-4 col-xs-6 label-item pl-0">Tên đăng nhập</label>
                                                <div
                                                    className="col-md-8 col-xs-6 pl-0 font-weight-bold kt-margin-b-10-tablet-and-mobile">
                                                    {localStorage.getItem("username")}
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 col-xs-6 label-item pl-0">Tên hiển thị(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    placeholder="Tên hiển thị"
                                                    className={this.state.fullNameErr ? "form-control border-input-error kt-input pd-4-input hei-input" : "form-control kt-input pd-4-input hei-input"}
                                                    value={this.state.fullName}
                                                    onChange={(val) => this.setState({
                                                        fullName: val.target.value.trimLeft(),
                                                        inEditing: true
                                                    }, () => {
                                                        this.state.fullName.length === 0 || this.state.fullName.length < 5 ? this.setState({
                                                            fullNameErr: true,
                                                            btnSaveStatus: false
                                                        }) : this.setState({
                                                            fullNameErr: false,
                                                            btnSaveStatus: true
                                                        })
                                                    })}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 col-xs-6 label-item pl-0">SĐT(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    placeholder="Số điện thoại"
                                                    className={this.state.phoneErr ? "form-control border-input-error kt-input pd-4-input hei-input" : "form-control kt-input pd-4-input hei-input"}
                                                    value={this.state.phone1}
                                                    onChange={(val) => this.setState({
                                                        phone1: val.target.value.trimLeft().replace(/[^0-9]/g, ''),
                                                        inEditing: true
                                                    }, () => {
                                                        this.state.phone1.length === 0 || this.state.phone1.length < 10 ? this.setState({
                                                            phoneErr: true,
                                                            btnSaveStatus: false
                                                        }) : this.setState({
                                                            phoneErr: false,
                                                            btnSaveStatus: true
                                                        })
                                                    })}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 col-xs-6 label-item pl-0">Email(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    maxLength={255}
                                                    type="text"
                                                    placeholder="Nhập Email"
                                                    className={this.state.emailErr ? "form-control border-input-error kt-input pd-4-input hei-input" : "form-control kt-input pd-4-input hei-input"}
                                                    value={this.state.email}
                                                    onChange={(val) => {
                                                        if (Utils.checkEmailRegex(val.target.value.trim())) {
                                                            this.setState({
                                                                email: val.target.value.trim(),
                                                                emailErr: true,
                                                                btnSaveStatus: false
                                                            })
                                                        }else{
                                                            this.setState({
                                                                email: val.target.value.trim(),
                                                                emailErr: false,
                                                                inEditing: true,
                                                                btnSaveStatus: true
                                                            })
                                                        }
                                                    }
                                                    }
                                                />
                                            </div>

                                            <AddressManager
                                                addressUsually={addressUsually}
                                                districtId={districtId}
                                                provinceId={provinceId}
                                                wardId={wardId}
                                                onUpdateAddress={(addressUsually, wardId, districtId, provinceId) => this.setState({addressUsually: addressUsually, districtId: districtId, provinceId: provinceId, wardId: wardId, btnSaveStatus: true})}
                                            />
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 col-xs-6 label-item pl-0">Giới tính(<span  style={{color: "red",}}>*</span>)</label>
                                                <div className='d-flex col-md-12'>
                                                    <div className="form-check col-md-6 ">
                                                        <input className="form-check-input" type="radio"
                                                               name="femaleRadios" id="female" value="FEMALE"
                                                               onClick={(val) => {
                                                                   this.setState({
                                                                       gender: val.target.value,
                                                                       inEditing: true,
                                                                       btnSaveStatus: true
                                                                   })
                                                               }}
                                                               checked={this.state.gender === 'FEMALE'}
                                                        />
                                                        <label className="form-check-label"
                                                               htmlFor="exampleRadios1">
                                                            Nữ
                                                        </label>
                                                    </div>
                                                    <div className="form-check col-md-6">
                                                        <input className="form-check-input" type="radio"
                                                               name="maleRadios" id="male" value="MALE"
                                                               onClick={(val) => {
                                                                   this.setState({
                                                                       gender: val.target.value,
                                                                       inEditing: true,
                                                                       btnSaveStatus: true
                                                                   })
                                                               }}
                                                               checked={this.state.gender === 'MALE'}
                                                        />
                                                        <label className="form-check-label"
                                                               htmlFor="exampleRadios1">
                                                            Nam
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 d-flex mb-2">
                                                <label className="col-md-4 label-item pl-0">CMND/CCCD(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    maxLength={255}
                                                    type="text"
                                                    placeholder="Nhập số CMND/CCCD"
                                                    className={this.state.identifyErr ? "form-control border-input-error kt-input pd-4-input hei-input" : "form-control kt-input pd-4-input hei-input"}
                                                    value={this.state.identifyCard}
                                                    onChange={(val) => this.setState({
                                                        identifyCard: val.target.value.trim().replace(/[^0-9]/g, ''),
                                                        inEditing: true
                                                    }, () => {
                                                        this.state.identifyCard.length === 0 || this.state.identifyCard.length < 9 ? this.setState({
                                                            identifyErr: true,
                                                            btnSaveStatus: false
                                                        }) : this.setState({
                                                            identifyErr: false,
                                                            btnSaveStatus: true
                                                        })
                                                    })}
                                                />
                                            </div>
                                            <div className="col-md-6 d-flex mb-2">
                                                <label className="col-md-4 label-item pl-0">Ngày cấp(<span  style={{color: "red",}}>*</span>)</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.dateIdentifyCard === '' ? null : new Date(this.state.dateIdentifyCard)}
                                                    maxDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    dateIdentifyCard: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                    inEditing: true
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-6 d-flex mb-2">
                                                <label className="col-md-4 label-item pl-0">Nơi cấp(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    maxLength={255}
                                                    type="text"
                                                    placeholder="Nhập nơi cấp"
                                                    value={this.state.provinceIdentifyCard}
                                                    className={this.state.placeIssueErr ? "form-control border-input-error kt-input pd-4-input hei-input" : "form-control kt-input pd-4-input hei-input"}
                                                    onChange={(val) => this.setState({
                                                        provinceIdentifyCard: val.target.value.trimLeft(),
                                                        inEditing: true
                                                    }, () => {
                                                        this.state.provinceIdentifyCard.length === 0 ? this.setState({
                                                            placeIssueErr: true,
                                                            btnSaveStatus: false
                                                        }) : this.setState({
                                                            placeIssueErr: false,
                                                            btnSaveStatus: true
                                                        })
                                                    })}
                                                />
                                            </div>
                                        </div>
                                    }
                                    {/*End Hien thi chỉnh sửa*/}
                                    {/*Hien thi K chỉnh sửa*/}
                                    {
                                        !this.state.onEdit &&

                                        <div className='row'>
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 pl-0">Tên đăng nhập</label>
                                                <label className="col-md-4 pl-0 font-weight-bold">  {localStorage.getItem("username")}</label>
                                            </div>
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 pl-0">Tên hiển thị</label>
                                                <label className="col-md-4 pl-0"> {dataInfo.fullName}</label>
                                            </div>

                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 pl-0">Số điện thoại</label>
                                                <label className="col-md-4 pl-0"> {dataInfo.phone1}</label>
                                            </div>

                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 pl-0">Email</label>
                                                <label className="col-md-4 pl-0"> {dataInfo.email}</label>
                                            </div>

                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 pl-0">Địa chỉ</label>
                                                <label className="col-md-4 pl-0"> {dataInfo.addressUsually ? dataInfo.addressUsually : ''}</label>
                                            </div>

                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 pl-0">Tỉnh/Thành phố</label>
                                                <label className="col-md-4 pl-0"> {dataInfo.provinceRes ? dataInfo.provinceRes.fullName : ''}</label>
                                            </div>

                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 pl-0">Quận/Huyện</label>
                                                <label className="col-md-4 pl-0"> {dataInfo.districtRes ? dataInfo.districtRes.fullName : ''}</label>
                                            </div>

                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 pl-0">Xã/Phường</label>
                                                <label className="col-md-4 pl-0"> {dataInfo.wardRes ? dataInfo.wardRes.fullName : ''}</label>
                                            </div>

                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 pl-0">Giới tính</label>
                                                <label className="col-md-4 pl-0"> {dataInfo.gender ? dataInfo.gender == 'MALE' ? 'Nam' : 'Nữ' : ''}</label>
                                            </div>

                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 pl-0">CMND/CCCD</label>
                                                <label className="col-md-4 pl-0"> {dataInfo.identifyCard ? dataInfo.identifyCard : ''}</label>
                                            </div>

                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 pl-0">Ngày cấp</label>
                                                <label className="col-md-4 pl-0"> {dataInfo.dateIdentifyCard ? moment(dataInfo.dateIdentifyCard).format("DD-MM-YYYY") : ''}</label>
                                            </div>

                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-md-4 pl-0">Nơi cấp</label>
                                                <label className="col-md-4 pl-0"> {dataInfo.provinceIdentifyCard ? dataInfo.provinceIdentifyCard : ''}</label>
                                            </div>
                                        </div>
                                    }
                                    {/*End Hien thi K chỉnh sửa*/}
                                </div>

                                {this.state.onEdit ?
                                    <div className="justify-flex-center">
                                        <div className='text-center col-md-12'>
                                            {this.state.loading &&
                                            <button
                                                type="button"
                                                className="border-1-s mr-2 background-btn type-button-fix btn btn-primary btn-sm shadow-none"
                                            >
                                                <CircularProgress size={20} variant="determinate"
                                                                  value={this.state.progress}/>
                                            </button>}
                                            {!this.state.loading &&
                                            <button
                                                disabled={!this.state.btnSaveStatus}
                                                type="button"
                                                className="border-1-s mr-2 background-btn type-button-fix btn btn-primary btn-sm shadow-none"
                                                onClick={() => this.handleSave()}
                                            >
                                                Lưu
                                            </button>
                                            }
                                            <button type="button"
                                                    className="border-1-s pr-2 mr-2 type-button-fix btn btn-light btn-sm shadow-none"
                                                    onClick={() => this.handleCancel()}
                                            >
                                                Hủy
                                            </button>
                                        </div>
                                    </div>
                                    : <div className="justify-flex-center">
                                        <div className='col-md-12 text-center'
                                             style={{textTransform: 'initial'}}
                                        >
                                            <button
                                                type="button"
                                                className="border-1-s mr-2 background-btn type-button-fix btn btn-primary btn-sm shadow-none"
                                                onClick={() => this.setState({onEdit: !this.state.onEdit})}
                                            >
                                                Chỉnh sửa thông tin
                                            </button>
                                            <button type="button"
                                                    className="border-1-s pr-2 mr-2 type-button-fix btn btn-light btn-sm shadow-none"
                                                    onClick={() => this.handleShowModalForgotPassword()}
                                            >
                                                Đổi mật khẩu
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>

                            <ModalChangePassword show={this.state.showModalChangePassword}
                                                 onHideModal={this.onCloseModalForgotPassword}/>

                            <ModalConfirmEdit show={this.state.confirmCancel}
                                              onHide={() => this.setState({confirmCancel: false})}
                                              handleCancel={
                                                  () => this.setState({
                                                      confirmCancel: false,
                                                      inEditing: false
                                                  }, () => this.handleCancel())
                                              }
                            />
                            {this.state.showUpload && <UploadFile show={this.state.showUpload}
                                                                  onHide={() => this.setState({showUpload: false})}/>}
                        </div>
                    </div>
                </div>
                <ModalChangeAvatar show={this.state.modalUploadAvatar}
                                   onHide={this.modalUploadAvatarClose}
                                   updateSuccess={()=> {
                                       this.setState({modalUploadAvatar: false})
                                       this.getPartnerInfo()
                                   }}
                />
                <ModalConfirmDeleteCert show={this.state.modalConfirmDeleteCert}
                                        onHide={() => this.setState({modalConfirmDeleteCert: false})}
                                        fileId={this.state.fileId}/>
                {/*<ModalCropImage show={this.state.showModalCrop} onHide={this.modalCropClose}*/}
                {/*                   customerId={1}/>*/}
            </div>
        );
    }
}

export default ProfilePartner
